<!-- AI Insights summary panel -->
<div class="wccard d-flex flex-column mb-1" style="padding-top:8px; padding-bottom:8px;">
  <app-ai-sourcing-insights-ai
    [totalcount]="totalCandidatesCount"
    [insightsaidata]="insightsData"
    [events]="insightsSubject.asObservable()">
  </app-ai-sourcing-insights-ai>
</div>

<!-- Five-metric stat bar -->
<div class="" *ngIf="projectDetails">
  <div class="">
    <div class="wccard d-flex justify-content-between mb-1 px-2 py-2" style="gap:10px;">

      <!-- Talent Count -->
      <div class="d-flex align-items-center four-matrix" style="cursor:default;">
        <div *ngIf="!totalCandidatesCountAvailable" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width:15%;" alt="talent count">
        </div>
        <div class="talent-data-card" *ngIf="totalCandidatesCountAvailable">
          <span class="f-18 font-weight-600">{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
          <p class="text-9696 f-12 mb-0">Talent Count</p>
        </div>
      </div>

      <!-- Median Tenure -->
      <div class="d-flex align-items-center four-matrix" style="cursor:default;">
        <div *ngIf="!medianTenureInCountAvailable" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width:15%;" alt="median tenure">
        </div>
        <div class="talent-data-card" *ngIf="medianTenureInCountAvailable">
          <span class="f-18 font-weight-600" [innerHTML]="getFormattedTenureForMatrix(totalMedianTanureCount)"></span>
          <p class="text-9696 f-12 mb-0">
            Median Tenure
            <i class="fas fa-info-circle" matTooltip="Median Tenure of the talent"
              [matTooltipClass]="{'big-tooltip text-black': true}"></i>
          </p>
        </div>
      </div>

      <!-- Changed Jobs -->
      <div class="d-flex align-items-center four-matrix">
        <div *ngIf="!changedJobsCountAvailable" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width:15%;" alt="changed jobs">
        </div>
        <div class="talent-data-card" *ngIf="changedJobsCountAvailable">
          <span class="f-18 font-weight-600">{{formatNumberToIndianFormat(changedJobs)}}</span>
          <p class="text-9696 f-12 mb-0">Changed Jobs (past 1yr)</p>
        </div>
      </div>

      <!-- Active Job Posts -->
      <div class="d-flex align-items-center four-matrix">
        <div *ngIf="hasJobDemand" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width:15%;" alt="active job posts">
        </div>
        <div class="talent-data-card" *ngIf="!hasJobDemand">
          <p class="f-18 font-weight-600 mb-0">
            <span *ngIf="jobDemandCount && jobDemandCount !== '0'">{{jobDemandCount}}</span>
            <span *ngIf="!jobDemandCount" style="font-family:Arial,sans-serif;">&mdash;</span>
          </p>
          <p class="f-12 text-9696 mb-0">Active Job Posts</p>
        </div>
      </div>

      <!-- Salary Range -->
      <div class="d-flex align-items-center four-matrix">
        <div *ngIf="hasJobDemand" class="text-center">
          <img src="../../assets/rolling-loader.gif" style="width:15%;" alt="salary range">
        </div>
        <div class="talent-data-card" *ngIf="!hasJobDemand">
          <p class="f-18 font-weight-600 mb-0">
            <span *ngIf="medianSalary" [innerHTML]="medianSalary"></span>
            <span *ngIf="!medianSalary" style="font-family:Arial,sans-serif;">&mdash;</span>
          </p>
          <p class="f-12 text-9696 mb-0">Salary Range</p>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Charts / detailed insights -->
<div class="">
  <div class="">
    <app-person-search-insights
      *ngIf="projectDetails"
      (insightsEvents)="insightsEventHandler($event)"
      [projectnumber]="projectnumber"
      [aiSourcingContinent]="projectDetails?.continent"
      [calledFrom]="'project-talent-insights'">
    </app-person-search-insights>
  </div>
</div>

<!-- Holding modal: shown while autopilot sourcing is still running -->
<ng-template #holdingTemplate>
  <div class="modal-content">
    <div class="modal-header hire-modal-header w-100">
      <div class="d-flex justify-content-between text-defualt w-100">
          <span class="font-weight-600">We're finding the best candidates for your role</span>
          <span class="f-14 font-weight-600 pointer"  (click)="dismiss()">
            <span>
            <i class="fa-solid fa-times" aria-hidden="true"></i>
          </span>
        </span>
      </div>
    </div>
    <div class="modal-body px-3">
      <div class="">
        <p class="mb-2 text-black f-12">We're searching, ranking, and matching candidates based on your project requirements. This may take a few moments. In the meantime, you can explore Talent Insights while your candidate list is being prepared.</p>
        <button data-testid="auto-app-project-talent-insights-button-1"  class="btn-trms-medium m-0 outside-btn" (click)="dismiss()"><span >Got it </span></button>
      </div>
    </div>
  </div>
</ng-template>
